import React from 'react'
import { CMSOpportunityDetailsLeadershipTeamType } from '../../../lib/types'
import { LinkedInIcon, P, RichTextRenderer } from '../../../lib/components'
import { resolveCmsImageUrl } from './utils'
import { CmsSectionText } from './cms-section-text-content'

const CMSLeadershipTeam = ({
  leadershipTeam,
}: {
  leadershipTeam?: CMSOpportunityDetailsLeadershipTeamType
}) => {
  const renderMemberAvatar = (
    member: NonNullable<CMSOpportunityDetailsLeadershipTeamType['teamMembers']>[number],
    idx: number,
  ) => {
    const imageUrl = resolveCmsImageUrl(member.image as unknown)
    const initial = (member.name || '?').trim().charAt(0).toUpperCase() || '?'

    return (
      <div className={`opportunity-hero-logo${imageUrl ? ' opportunity-hero-logo--image' : ''}`}>
        {imageUrl ? <img src={imageUrl} alt={member.name || `Team member ${idx + 1}`} /> : initial}
      </div>
    )
  }

  const renderText = () => {
    if (!leadershipTeam?.text?.length) {
      return null
    }

    return (
      <CmsSectionText as='section' dataTestId='cms-leadership-team-text'>
        <RichTextRenderer content={leadershipTeam.text} variant='opportunity-details' />
      </CmsSectionText>
    )
  }

  return (
    <section data-testid='cms-leadership-team-content'>
      {leadershipTeam?.text?.length && leadershipTeam?.sectionPosition === 'top' && renderText()}

      {leadershipTeam?.teamMembers?.length ? (
        <section data-testid='cms-leadership-team-members'>
          {leadershipTeam.teamMembers.map((member, idx) => (
            <section className='flex gap-40px opportunity-cms-section-spaced-block' key={idx}>
              <section className='opportunity-team-member-avatar-wrap'>
                {renderMemberAvatar(member, idx)}
              </section>
              <section className='flex-5'>
                <section className='flex flex-space-between'>
                  <P
                    text={
                      <span>
                        <strong>{member.name}</strong> - {member.designation}
                      </span>
                    }
                    textSize='small'
                  />
                  {member.linkedInUrl && (
                    <a
                      href={member.linkedInUrl}
                      target='_blank'
                      rel='noreferrer'
                      data-testid={`cms-leadership-team-linkedin-link-${idx + 1}`}
                    >
                      <LinkedInIcon />
                    </a>
                  )}
                </section>
                {member.about?.length ? (
                  <CmsSectionText className='mt-12px'>
                    <RichTextRenderer content={member.about} variant='opportunity-details' />
                  </CmsSectionText>
                ) : null}
              </section>
            </section>
          ))}
        </section>
      ) : null}

      {leadershipTeam?.text?.length && leadershipTeam?.sectionPosition === 'bottom' && renderText()}
    </section>
  )
}

export { CMSLeadershipTeam }
